import { createContext } from 'preact';
const TableContext = createContext({});
export default TableContext;
//# sourceMappingURL=TableContext.js.map